import { AssetsCode } from "@gtpl/shared-models/common-models";
import { AssetsClassification } from "./assets-classification-entity";
import { AssetsClassificationDTO } from "./dto/assets-classification-dto";





export class AssetsClassificationAdapter {

    public convertDtoToEntity(details: AssetsClassificationDTO): AssetsClassification {
        const assets = new AssetsClassification();
        if (details.assetsClassificationId) {
            assets.assetsClassificationId = details.assetsClassificationId;
            assets.updatedUser = details.updatedUser;
        }
        assets.assetsClassificationName = details.assetsClassificationName;
        assets.assetCodeRequired = AssetsCode.REQUIRED;
        assets.assetsClassificationCode = details.assetsClassificationCode;
        assets.createdUser = details.createdUser;
        return assets;
    }

}